import { gsap, Power2, Linear } from 'gsap'

function isMobile(){
	return (innerWidth < 1240)
}

const width = window.outerWidth
const logoRect = document.querySelector('#nav .logo svg .logorectangle')
const logoPoint = document.querySelector('#nav .logo svg .logopoint')

const tl_logo_1 = gsap.timeline({
	repeat: 3,
	repeatDelay: 0.2,
	onComplete: () =>
	{
		tl_logo_2.play()
	}
})

const tl_logo_2 = gsap.timeline({
	paused: true,
	onComplete: () =>
	{
		tl_logo_3.play()
		
		if (document.body.classList.contains('home'))
		{
			animHeader()
		}
	}
})

const tl_logo_3 = gsap.timeline({
	repeat: -1,
	repeatDelay: 2,
	delay: 1,
	paused: true
}).to(logoPoint, {
	scale: 1.5,
	transformOrigin: 'center',
	duration: .8,
	ease: Power2.easeOut
}).to(logoPoint, {
	scale: 1,
	transformOrigin: 'center',
	duration: .8,
	ease: Power2.easeOut
})

gsap.set(logoPoint, {
	x: -650,
	y: -225
})

tl_logo_1.to(logoPoint, {
	opacity: 0,
	duration: 0.1
}).to(logoPoint, {
	opacity: 1,
	duration: 0.1,
	delay: 0.2
})

tl_logo_2.to(logoPoint, {
	x: -150,
	duration: 0.8
}).to(logoRect, {
	x: 512,
	duration: 0.8
}, '-=0.7')

function animHeader(){
	const headerClip = document.querySelector('#header .img_clip')
	const headerTitle = document.querySelector('#header h1')
	const headerTitlePointOffsetTop = headerTitle.offsetTop + headerTitle.clientHeight - (isMobile() ? 12 : 28)
	const headerTitlePointOffsetLeft1 = headerTitle.offsetLeft
	const headerTitlePointOffsetLeft2 = headerTitle.offsetLeft + (isMobile() ? 200 : 490)
	
	const tl_header = gsap.timeline({
		paused: false
	})
	
	const tl_title = gsap.timeline({
		paused: true,
		repeat: -1,
		repeatDelay: 1,
		/*onRepeat: () => {
			gsap.to(headerTitle.querySelectorAll('li'), {
				width: 0,
				opacity: 0,
				duration: 0.5
			})
			
			gsap.to(headerTitle.querySelectorAll('li'), {
				width: 'auto',
				opacity: 1,
				duration: 0.5,
				delay: 0.5
			})
		},*/
	})
	
	let headerTitleOffset = 0
	
	headerTitle.querySelectorAll('li').forEach((el, index) =>
	{
		headerTitleOffset = el.offsetHeight * index * -1
		
		tl_title.to(headerTitle.querySelectorAll('li'), {
			y: headerTitleOffset,
			duration: 1,
			delay: index === 0 ? 0 : 0.5,
			ease: Power2.easeInOut
		})
	})
	
	gsap.set(headerClip, {
		clipPath: `circle(7px at ${width}px ${headerTitlePointOffsetTop}px)`
	})
	
	tl_header.to(headerClip, {
		clipPath: `circle(7px at ${headerTitlePointOffsetLeft1}px ${headerTitlePointOffsetTop}px)`,
		duration: 1.2,
		ease: Power2.easeInOut
	}).to(headerClip, {
		clipPath: `circle(7px at ${headerTitlePointOffsetLeft2}px ${headerTitlePointOffsetTop}px)`,
		duration: 1.2,
		ease: Power2.easeOut
	}, '+=0.6').to(headerTitle, {
		width: 'auto',
		duration: 1.2,
		ease: Power2.easeOut
	}, '-=1').to(headerClip, {
		clipPath: `circle(${width}px at ${headerTitlePointOffsetLeft2}px ${headerTitlePointOffsetTop}px)`,
		duration: 1.5,
		ease: Power2.easeInOut
	}, '-=0.7').to(headerClip, {
		filter: 'brightness(1)',
		duration: 0,
		ease: Power2.easeInOut,
		onComplete: () =>
		{
			tl_title.play()
		}
	}, '-=1.7')
}

document.querySelectorAll('.button').forEach(el =>
{
	const hover = document.createElement('div')
	
	hover.className = 'hover'
	
	el.insertAdjacentElement('afterbegin', hover)
	
	el.addEventListener('mouseenter', e =>
	{
		if (el !== e.target)
		{
			return
		}
		
		gsap.set(hover, {
			left: e.pageX - getOffset(el).x,
			top: e.pageY - getOffset(el).y,
			x: '-50%',
			y: '-50%',
			width: el.clientWidth * 2 + 10,
			height: el.clientWidth * 2 + 10,
			scale: 0,
			opacity: .5
		})
		
		gsap.to(hover, {
			scale: 1,
			opacity: 1,
			duration: .5,
			ease: Power2.easeOut
		})
	})
	
	el.addEventListener('mouseleave', e =>
	{
		gsap.to(hover, {
			scale: 0,
			opacity: .5,
			duration: .5,
			ease: Power2.easeOut
		})
	})
})

function getOffset (el)
{
	return {
		x: el.getBoundingClientRect().x + window.scrollX,
		y: el.getBoundingClientRect().y + window.scrollY
	}
}
